import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import UpdateBanner from "./components/UpdateBanner/UpdateBanner.tsx";
import "./css/style.css";
import "./css/satoshi.css";
import "./css/simple-datatables.css";
import "jsvectormap/dist/jsvectormap.css";
import "nouislider/dist/nouislider.css";
import "flatpickr/dist/flatpickr.min.css";
import "dropzone/dist/dropzone.css";
import * as Sentry from "@sentry/react";
import { APP_VERSION } from "./version";

// @ts-ignore
const appEnv = import.meta.env.VITE_APP_ENV as string;
// @ts-ignore
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string;

const isStaging = appEnv === "staging";
const isProduction = appEnv === "production";

console.log("Project initialized in " + appEnv + " environment");

if ((isStaging || isProduction) && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: appEnv,
    release: __APP_RELEASE__,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: isProduction
          ? [/^https:\/\/libra\.wing\.bg/]
          : [/^https:\/\/beta\.librains\.com/],

        networkCaptureBodies: true,
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
        failedRequestTargets: isProduction
          ? [/^https:\/\/libra\.wing\.bg/]
          : [/^https:\/\/beta\.librains\.com/],
      }),
    ],
    tracesSampleRate: isProduction ? 1.0 : 0.2,
    tracePropagationTargets: isProduction
      ? ["https://libra.wing.bg"]
      : ["https://beta.librains.com/"],
    replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  });

  console.log(`✅ Sentry initialized in ${appEnv} mode.`);
} else {
  console.log("🛑 Sentry is disabled (local environment).");
}

console.log(
  `web-insurance build #${APP_VERSION.build} (${APP_VERSION.commit}) built ${APP_VERSION.builtAt}`
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Router>
      <App />
      <UpdateBanner />
    </Router>
  </React.StrictMode>
);
